import { useState, useEffect } from 'react';
//import axios from 'axios';
import api from '../services/api';

export default function useFind(url,pre=[]) {
    const [data, setData] = useState(pre);
    const [error, setError] = useState(false);
    const [isLoading, setLoading] = useState(true);

    useEffect(() =>{
        //-------------------------------------------
        const msg_erro = {
            messages: "⚠ Erro de conexão, verifique a conexão com a internet ou tente novamente mais tarde"
        }
        const cath_network = (err) => {
            // console.log({err})
            if (err.response) {
                return setError(err.response.data)
            }
            if (err.Error === "Network Error") {
                setError(msg_erro)
            }
            setLoading(false)
            return setError(msg_erro)
        }
        //-------------------------------------------
        async function findData() {
            await api.get(url)
                .then(res => {
                    setData(res.data);
                    setLoading(false);
                }).catch(cath_network);
        };

        findData();
    }, [url]);

    return {
        data,
        setData,
        isLoading,
        error,
    }
}
